import { Grid } from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { CertificationFormVM } from 'front-office/view-models/document-birth-form';
import { useFormikContext } from 'formik';
import { memo, useMemo } from 'react';
import { StepButton, StepTypography } from 'shell/components/shared/step-button';
import { StickyDiv } from 'shell/components/shared/sticky-div';
import PmiTooltipError from 'shell/components/shared/tooltip-error';
import { noop } from 'shell/utils/noop';

const steps: Array<Record<string, string>> = [
  {
    label: 'Richiedente',
  },
  {
    label: 'Scelta certificazione',
  },
  {
    label: 'Ricerca atto',
  },
  {
    label: 'Visualizzazione atto',
  },
  {
    label: 'Stampa',
  },
];

interface ButtonsProps {
  handleExit: () => void;
  disabled?: boolean;
  handleStep?: (id: number, resolve?: (value: unknown) => void) => void;
  activeStep?: number;
}

const ButtonsComponent = ({
  handleExit,
  disabled,
  handleStep = noop,
  activeStep = 0,
}: ButtonsProps): React.ReactElement => {
  const formContext = useFormikContext<CertificationFormVM>();

  const isDisabledRequestCertificate = useMemo(() => {
    if (!formContext.errors || Object.values(formContext.errors).length === 0) {
      return '';
    }
    if (activeStep === 0) {
      return 'Il form del Richiedente non è valido';
    }
    if (activeStep === 1) {
      return formContext.errors.certificate;
    }
    if (activeStep === 2) {
      return "Il form dell'atto non è valido";
    }
    if (activeStep === 3) {
      return "Il form dell'atto non è valido";
    }
    if (activeStep === 4) {
      return 'Il form della stampa non è valido';
    }
  }, [formContext.errors, activeStep]);

  return (
    <StickyDiv>
      <div>
        <Grid container spacing={1}>
          {steps.map((step, index) => (
            <Grid item xs={12} key={step.label?.toString()}>
              <PmiTooltipError
                message={isDisabledRequestCertificate}
                show={!!isDisabledRequestCertificate && activeStep === index}
              >
                <span>
                  <StepButton
                    active={index === activeStep}
                    disabled={disabled || activeStep < index}
                    variant="outlined"
                    color="cdmBrandThird"
                    fullWidth
                    onClick={async (event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      if (index === 2) {
                        formContext.setFieldValue('chosenDocument', null);
                        await Promise.resolve();
                      }
                      handleStep(index);
                    }}
                  >
                    <StepTypography
                      active={index === activeStep}
                      disabled={disabled || activeStep < index}
                    >
                      {step.label}
                    </StepTypography>
                  </StepButton>
                </span>
              </PmiTooltipError>
            </Grid>
          ))}
        </Grid>
        <div>
          <div className="pmi-pt-3">
            <PmiButton variant="outlined" color="cdmBrand" fullWidth onClick={handleExit}>
              Esci
            </PmiButton>
          </div>
        </div>
      </div>
    </StickyDiv>
  );
};

ButtonsComponent.displayName = 'Certification Civil Status Form - Buttons';

const Buttons = memo(ButtonsComponent);

export default Buttons;
